import { render } from "./EconomicDependent.vue?vue&type=template&id=f41cf238&scoped=true"
import script from "./EconomicDependent.vue?vue&type=script&lang=js"
export * from "./EconomicDependent.vue?vue&type=script&lang=js"

import "./EconomicDependent.vue?vue&type=style&index=0&id=f41cf238&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41cf238"]])

export default __exports__